import { styled } from "styled-components";

export const Wrapper = styled.div`
  transition: height 0.3s ease;
  will-change: height;
  height: 500px;
  position: relative;
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  overflow: hidden;
`;

export const Inner = styled.div`
  gap: ${({ theme }) => theme.spacing["3"]};
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow-y: auto;
  margin-top: ${({ theme }) => theme.spacing[3]};
`;

export const SpinnerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
`;

export const Item = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: ${({ theme }) => theme.spacing[3]};
  border: 1px solid ${({ theme }) => theme.colors.border.weak};
  width: 100%;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.colors.background.layers[500]};
  }
`;

export const Header = styled.div`
  display: flex;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.weak};
  padding-bottom: ${({ theme }) => theme.spacing["5"]};
  margin-bottom: ${({ theme }) => theme.spacing["5"]};
`;

export const HeaderTitle = styled.div`
  font-size: 32px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.text.primary.color};
`;

export const Content = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  gap: 2px;
  height: 32px;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 30px;
  color: ${({ theme }) => theme.colors.text.primary.color};
  padding-right: ${({ theme }) => theme.spacing[4]};
`;

export const Title = styled.div`
  font-size: ${({ theme }) => theme.fonts.medium.fontSize};
  color: ${({ theme }) => theme.colors.text.primary.color};
`;

export const Checkbox = styled.div<{ checked: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ theme }) => theme.spacing[5]};
  min-width: ${({ theme }) => theme.spacing[5]};
  height: ${({ theme }) => theme.spacing[5]};
  border-radius: 50%;
  background-color: ${({ checked, theme }) =>
    checked ? theme.colors.icon.success : theme.colors.background.layers[700]};
  border: 1px solid ${({ theme }) => theme.colors.border.weak};
  margin-right: ${({ theme }) => theme.spacing[2]};
  color: #fff;
`;
